module.exports = __webpack_public_path__ + "img/praiseSuccess.63c8a8eb.png";